<ngx-ui-loader text="Please wait" fgsColor="#487bff" pbColor="#487bff"></ngx-ui-loader>
<div ngxUiLoaderBlurred >
    <router-outlet (activate)="onActivate()"></router-outlet>
</div>